module.exports = __webpack_public_path__ + "static/media/barrel1.97ea1e82.jpg";